// Angular
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
// 3rdparty
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';

// Hostware
import { SpinnerService } from '@app/core/services/spinner.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { KipUserGroupService } from '@app/kip/services/kip-usergroup.service';
import { KipUserGroup } from '@app/kip/dto/KipUserGroup';
import { RequestResult } from '@app/core/dto/RequestResult';
import { DynamicControlDescriptor } from '@app/kip/classes/DynamicControlDescriptor';
import { ChipsTypes } from '@app/kip/enums/ChipsTypes';
import { HokParamsService } from '@app/kip/services/hok-params.service';


@AutoUnsubscribe()
@Component({
  selector: 'detailed-performance-report-filter',
  templateUrl: './detailed-performance-report-filter.component.html',
  styleUrls: ['./detailed-performance-report-filter.component.scss']
})




export class DetailedPerformanceReportFilterComponent implements OnInit, OnDestroy {

  @Output() filterChanged: EventEmitter<PerformanceReportFilterParameter> =  new EventEmitter<PerformanceReportFilterParameter>() ;

  filterForm: FormGroup;
  userGroups : KipUserGroup[] = [];
  loaded: boolean = false;
  dynamicControlDescriptor: DynamicControlDescriptor[] = [];
  tmpDynamicControlDescriptor: DynamicControlDescriptor[] = [];
  loadAllUserGroups$: Subscription;

  constructor(
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    private sessionStorageService: SessionStorageService,
    private kipUserGroupService: KipUserGroupService,
    private hokParamsService : HokParamsService,
    private fb: FormBuilder

  ) {
    const endDate = dayjs();
    const startDate = dayjs();
    this.filterForm = fb.group({
      'fUserGroup': new FormControl(-1),
      'fDateFrom': new FormControl(startDate),
      'fDateTo': new FormControl(endDate)
    })
  }



  //#region =============== Angular Lifecyle events ============================================================================
  async ngOnInit(): Promise<void> {

    const froDate =  (await  firstValueFrom (this.hokParamsService.loadFroDatum(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId())) as RequestResult).Data
    const dayjsDate = dayjs(froDate);
    this.filterForm.controls["fDateFrom"].patchValue(dayjsDate);
    this.filterForm.controls["fDateTo"].patchValue(dayjsDate);
    
    let units = this.sessionStorageService.getSelectedUnit();
    let hotels = this.sessionStorageService.getSelectedHotelId();
    this.loadAllUserGroups$ = this.kipUserGroupService.loadAllMulti(units, hotels.toString()).subscribe(result => {
       var res = result as RequestResult;
      if (res) {
        this.userGroups = res.Data as Array<KipUserGroup>;
        let allGroup : KipUserGroup = { UserGroupId: -1, UserGroupName: this.translate.instant("common.all") ,HotelId: 0, Subscriber: "", Users: []}; 
        this.userGroups.splice(0, 0, allGroup);
        this.filterParamsChanged();
        this.loaded = true;

        this.filterChanged.emit({
          UserGroupId: this.filterForm.controls["fUserGroup"].value,
          DateFrom: this.filterForm.controls["fDateFrom"].value.format("YYYY.MM.DD"),
          DateTo: this.filterForm.controls["fDateTo"].value.format("YYYY.MM.DD")
        });
      }

      
    })
  };
  ngOnDestroy(): void {
   
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  setFilter() {
    this.filterChanged.emit({
      UserGroupId: this.filterForm.controls["fUserGroup"].value,
      DateFrom: this.filterForm.controls["fDateFrom"].value.format("YYYY.MM.DD"),
      DateTo: this.filterForm.controls["fDateTo"].value.format("YYYY.MM.DD")
    });
  }

  filterParamsChanged() {
    this.tmpDynamicControlDescriptor  = [];
    this.dynamicControlDescriptor = [];
    let  desc = new DynamicControlDescriptor();

    desc.controlType = ChipsTypes.LabelValue;
    desc.parameters = []
    desc.parameters.push({ Key:  this.translate.instant("common.date"), Value: this.filterForm.controls["fDateFrom"].value.format("YYYY.MM.DD") + " - " 
              + this.filterForm.controls["fDateTo"].value.format("YYYY.MM.DD") });
    this.tmpDynamicControlDescriptor.push(desc);

    desc = new DynamicControlDescriptor();
    desc.controlType = ChipsTypes.LabelValue;
    desc.parameters = []
    desc.parameters.push({ Key: this.translate.instant("K901p6.title"), Value: this.userGroups.find(item=> item.UserGroupId.toString() == this.filterForm.controls["fUserGroup"].value.toString()).UserGroupName });
    this.tmpDynamicControlDescriptor.push(desc);



    this.dynamicControlDescriptor = this.tmpDynamicControlDescriptor;

   
  }
  //#endregion =================================================================================================================
}

export class PerformanceReportFilterParameter {
  UserGroupId: number;
  DateFrom: string;
  DateTo: string;
}
